"use client";

import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';

export default function UTMTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!searchParams) return;

    // Get UTM parameters from URL
    const utmParams = {
      utm_campaign: searchParams.get('utm_campaign'),
      utm_medium: searchParams.get('utm_medium'),
      utm_term: searchParams.get('utm_term'),
      utm_source: searchParams.get('utm_source'),
      utm_content: searchParams.get('utm_content'),
    };

    // Set cookies only if URL parameter exists and cookie doesn't exist (24 hours expiry)
    if (utmParams.utm_campaign && !Cookies.get('utm_campaign')) {
      Cookies.set('utm_campaign', utmParams.utm_campaign, { expires: 1, path: '/' });
    }
    if (utmParams.utm_medium && !Cookies.get('utm_medium')) {
      Cookies.set('utm_medium', utmParams.utm_medium, { expires: 1, path: '/' });
    }
    if (utmParams.utm_term && !Cookies.get('utm_term')) {
      Cookies.set('utm_term', utmParams.utm_term, { expires: 1, path: '/' });
    }
    if (utmParams.utm_source && !Cookies.get('utm_source')) {
      Cookies.set('utm_source', utmParams.utm_source, { expires: 1, path: '/' });
    }
    if (utmParams.utm_content && !Cookies.get('utm_content')) {
      Cookies.set('utm_content', utmParams.utm_content, { expires: 1, path: '/' });
    }
  }, [searchParams]);

  return null;
}
